import { api } from '@cwd/lib/main';

export interface OrderCurrency {
    Name?: string;
    CurrencyCode: string;
}

export interface OrderCreditCard {
    CardType: string;
    Expires: string;
    Mask: string;
}

export interface OrderPayment {
    Amount: number;
    Created: string;
    CreditCard: OrderCreditCard | null;
    Currency: OrderCurrency;
}

export interface OrderServiceLevelPrice {
    MonthlyPrice: number;
    Currency: OrderCurrency;
    ServiceLevel: { Name: string };
    ServiceSubscriptionTier: { Name: string };
}

export interface Order {
    OrderId: string;
    OrderNumber: number;
    Created: string;
    Amount: number;
    Vat: number;
    VatPercentage: number;
    Status: number;
    StatusName: string;
    Type: number;
    TypeName: string;
    Currency: OrderCurrency;
    Payments?: OrderPayment[];
    ServiceLevelPrice?: OrderServiceLevelPrice | null;
}

export async function getOrders(): Promise<Order[]> {
    return api.get('/Orders');
}

export async function getOrder(orderId: string): Promise<Order> {
    return api.get('/Orders/' + orderId);
}
